import { Link } from 'react-router-dom';
import { newsItems } from '../../../mocks/news';

const categoryColors: Record<string, string> = {
  'お知らせ': 'border-forest-500/50 text-forest-300',
  '活動報告': 'border-gold-500/50 text-gold-400',
  '入会・協賛': 'border-cream-400/50 text-cream-400',
  'イベント': 'border-forest-400/50 text-forest-300',
};

export default function NewsSection() {
  const displayed = newsItems.slice(0, 4);

  return (
    <section className="bg-forest-700 py-24 md:py-32 relative overflow-hidden">
      {/* Decorative */}
      <div className="absolute right-0 top-0 w-72 h-72 rounded-full border border-cream-200/5 translate-x-1/3 -translate-y-1/3 pointer-events-none" />
      <div className="absolute right-0 top-0 w-48 h-48 rounded-full border border-cream-200/5 translate-x-1/3 -translate-y-1/3 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16">
          {/* Left */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-px bg-cream-400/40" />
              <span className="text-cream-400/60 text-xs font-serif tracking-widest2">NEWS</span>
            </div>
            <h2 className="text-cream-100 font-serif font-light text-3xl md:text-4xl tracking-wider leading-snug mb-4">
              お知らせ
            </h2>
            <p className="text-cream-400/70 text-sm font-serif leading-relaxed mb-8">
              協会からの最新情報をお届けします
            </p>
            <Link
              to="/news"
              className="inline-flex items-center gap-2 px-6 py-2.5 border border-cream-400/40 text-cream-300 text-xs font-serif tracking-widest hover:bg-cream-200/10 transition-colors duration-200 rounded-sm whitespace-nowrap cursor-pointer"
            >
              一覧を見る
              <i className="ri-arrow-right-line" />
            </Link>

            {/* Facebook */}
            <a
              href="https://www.facebook.com/people/OMFES-東洋医学未来推進協会/61586276497652/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="mt-8 flex items-center gap-3 p-4 border border-cream-400/20 hover:border-cream-400/40 transition-colors duration-200 cursor-pointer group"
            >
              <div className="w-9 h-9 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className="w-full h-full">
                  <rect fill="#1877F2" height="32" rx="4" width="32"/>
                  <path d="m18.4 10.5h2.1v-3.5h-2.4c-3 0-4.4 1.4-4.4 4.1v1.9h-2v3.5h2v8.5h3.5v-8.5h2.4l.4-3.5h-2.8v-1.5c0-.7.2-1 1.2-1z" fill="#ffffff"/>
                </svg>
              </div>
              <div>
                <p className="text-cream-300/80 text-xs font-serif tracking-wider group-hover:text-cream-100 transition-colors">
                  OMFES Facebookページ
                </p>
                <p className="text-cream-500/50 text-xs mt-0.5">最新情報はFacebookでも発信中</p>
              </div>
              <i className="ri-external-link-line text-cream-500/40 ml-auto group-hover:text-cream-400 transition-colors" />
            </a>
          </div>

          {/* Right - News list */}
          <div className="lg:col-span-3">
            <ul className="divide-y divide-forest-600/40">
              {displayed.map((item) => (
                <li key={item.id} className="py-5 first:pt-0 last:pb-0">
                  <Link to={`/news`} className="group flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4 cursor-pointer">
                    <div className="flex items-center gap-3 flex-shrink-0">
                      <time className="text-cream-500/60 text-xs font-serif tracking-wider whitespace-nowrap">
                        {item.date}
                      </time>
                      <span className={`text-xs font-serif px-2 py-0.5 border rounded-sm whitespace-nowrap ${categoryColors[item.category] || 'border-cream-400/40 text-cream-400'}`}>
                        {item.category}
                      </span>
                    </div>
                    <p className="text-cream-300/90 text-sm font-serif leading-relaxed group-hover:text-cream-100 transition-colors duration-200 line-clamp-2">
                      {item.title}
                    </p>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
